import CardLimit from './CardLimit';

export default CardLimit;